import { FixedComment } from "webportalclient";
import { v4 } from "uuid";

export const EcgAlertDefaults: FixedComment[] = [
    {
        id: v4(),
        comment: "Acute Myocardial Infarction",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 0
    },
    {
        id: v4(),
        comment: "ST Depression Or Elevation Of 2mm In Two Contiguous Leads (Ischemia)",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 1
    },
    {
        id: v4(),
        comment: "Ventricular Fibrillation",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 2
    },
    {
        id: v4(),
        comment: "Torsade De Pointes",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 3
    },
    {
        id: v4(),
        comment: "Ventricular Tachycardia (Run Of 3 Beats Or Greater)",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 4
    },
    {
        id: v4(),
        comment: "QTcB > 450 ms",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 5
    },
    {
        id: v4(),
        comment: "Bradycardia < 50 BPM",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 6
    },
    {
        id: v4(),
        comment: "Tachycardia > 100 BPM",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 7
    },
    {
        id: v4(),
        comment: "New Onset Of Atrial Flutter Or Atrial Fibrillation",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 8
    },
    {
        id: v4(),
        comment: "2nd Or 3rd Degree A/V Block",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 9
    },
    {
        id: v4(),
        comment: "Pauses > 2000 ms",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 10
    },
    {
        id: v4(),
        comment: "WPW Or Other Short PR Interval Conditions",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 11
    },
    {
        id: v4(),
        comment: "New Bundle Branch Block",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 12
    },
    {
        id: v4(),
        comment: "Atrial Fibrillation",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 13
    },
    {
        id: v4(),
        comment: "Atrial Flutter",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 14
    },
    {
        id: v4(),
        comment: "Cannot Rule Out Atrial Flutter",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 15
    },
    {
        id: v4(),
        comment: "Supraventricular Tachycardia",
        description: "",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 16
    },
]

const EcgInterpretations: string[] = [
    "Indeterminate Axis",
    "Left Axis Deviation",
    "Right Axis Deviation",
    "Abnormal Ecg",
    "Normal Ecg",
    "Technically Inadequate",
    "Consistent With Pulmonary Disease",
    "Incomplete Left Bundle Branch Block",
    "Incomplete Right Bundle Branch Block",
    "Intraventricular Conduction Delay",
    "Left Anterior Fascicular Block",
    "Left Bundle Branch Block",
    "Left Posterior Fascicular Block",
    "Left Ventricular Hypertrophy With Repolarization Abnormality",
    "Low QRS Voltage",
    "Low QRS Voltage in Chest Leads",
    "Low QRS Voltage in Limb Leads",
    "Nonspecific Intraventricular Conduction Delay",
    "Possible Left Ventricular Hypertrophy",
    "Possible Right Ventricular Hypertrophy",
    "Right Bundle Branch Block",
    "Right Bundle Branch Block Plus Possible Right Ventricular Hypertrophy",
    "Right Ventricular Hypertrophy",
    "Right Ventricular Hypertrophy With Repolarization Abnormality",
    "RSR (QR) in V1/V2 Consistent With Right Ventricular Conduction Delay",
    "S1-S2-S3 Pattern, Consistent With Pulmonary Disease, RVH, or Normal Variant",
    "Anterior Infarct",
    "Anterior Infarct, Age Undetermined",
    "Anterior Infarct, Possibly Acute",
    "Anterior Infarct, Probably Recent",
    "Anterolateral Infarct",
    "Anterolateral Infarct, Age Undetermined",
    "Anterolateral Infarct, Possibly Acute",
    "Anterolateral Infarct, Probably Recent",
    "Anteroseptal Infarct",
    "Anteroseptal Infarct, Age Undetermined",
    "Anteroseptal Infarct, Possibly Acute",
    "Anteroseptal Infarct, Probably Recent",
    "Inferior Infarct",
    "Inferior Infarct With Posterior Extension",
    "Inferior Infarct, Age Undetermined",
    "Inferior Infarct, Possibly Acute",
    "Inferior Infarct, Probably Recent",
    "Lateral Infarct",
    "Lateral Infarct, Age Undetermined",
    "Lateral Infarct, Possibly Acute",
    "Lateral Infarct, Probably Recent",
    "Possible Anterior Infarct",
    "Possible Anterolateral Infarct",
    "Possible Anteroseptal Infarct",
    "Possible Inferior Infarct",
    "Possible Lateral Infarct",
    "Possible Septal Infarct",
    "Septal Infarct",
    "Septal Infarct, Age Undetermined",
    "Septal Infarct, Possibly Acute",
    "Septal Infarct, Probably Recent",
    "True Posterior Myocardial Infarction",
    "Evolving",
    "Has Replaced",
    "Has Resolved",
    "Less Prominent",
    "More Prominent",
    "No Significant Changes",
    "Now Present",
    "Possible",
    "Abnormal QRS-T Angle",
    "Acute Pericarditis",
    "Digitalis Effect",
    "Early Repolarization",
    "Junctional Depression",
    "Long QT Interval",
    "Marked ST Depression Consistent With Subendocardial Injury",
    "Marked ST Depression, Possible Subendocardial Injury",
    "Nonspecific ST and T Wave Abnormality",
    "Nonspecific ST Elevation",
    "Possible Acute Pericarditis",
    "Short QT Interval",
    "ST and T Wave Abnormality Consistent With Anterior Ischemia",
    "ST and T Wave Abnormality Consistent With Anterolateral Ischemia",
    "ST and T Wave Abnormality Consistent With Inferior Ischemia",
    "ST and T Wave Abnormality Consistent With Lateral Ischemia",
    "ST Depression",
    "ST Depression, Possible Digitalis Effect",
    "ST Elevation Consistent With Epicardial Injury, Pericarditis, or Early Repolarization",
    "Tall T Waves, Possible Hyperkalemia",
    "Atrial Bradycardia",
    "Atrial Rhythm",
    "Atrial Tachycardia",
    "Sinus Bradycardia (HR Less Than 50)",
    "Sinus Rhythm",
    "Sinus Tachycardia",
    "With Sinus Arrhythmia",
    "With Marked Sinus Arrhythmia",
    "With First Degree AV Block",
    "With Short PR Interval",
    "Contour Analysis Based on Intrinsic Rhythm",
    "Dextrocardia",
    "Electronic Atrial Pacemaker",
    "Electronic Av Sequential Pacing",
    "Electronic Ventricular Pacemaker",
    "In a Pattern of Bigeminy",
    "Intermittent Wolff-Parkinson-White Pattern",
    "Junctional Rhythm",
    "Junctional Tachycardia",
    "Left Atrial Enlargement",
    "Possible Left Atrial Enlargement",
    "Possible Right Atrial Enlargement",
    "Right Atrial Enlargement",
    "Supraventricular Bradycardia",
    "Supraventricular Rhythm",
    "Torsades De Pointes",
    "Undetermined Rhythm",
    "Ventricular Fibrillation",
    "Ventricular Rhythm",
    "Ventricular Tachycardia",
    "With 2nd Degree AV Block, Mobitz Type I",
    "With 2nd Degree AV Block, Mobitz Type II",
    "With Aberrant Conduction or Ventricular Premature Complexes",
    "With Atrial Premature Complexes",
    "With AV Block",
    "With Ectopic Premature Complexes",
    "With Marked Rhythm Irregularity, Possible Non-conducted PAC, SA Block, AV Block, or Sinus Pause",
    "With Rapid Ventricular Response",
    "With Slow Ventricular Response",
    "With Supraventricular Premature Complexes",
    "With Variable Block",
    "With Ventricular Premature Complexes",
    "Wolff-Parkinson-White Pattern",
    "Arm Leads Reversed",
    "Automated Measurements Are Inaccurate"
]

export const EcgInterpretationDefaults: FixedComment[] = EcgInterpretations.map((inter, index) => ({
    id: v4(),
    comment: inter,
    description: "",
    followOnCommentAvailable: false,
    followOnCommentRequired: false,
    displayOrder: index
}));
